import axios from 'axios'
import { Toast } from 'vant'
import { userApi, traceApi } from '@/api/index.js'
import router from '../router'
import env from './env'
import store from '@/store/index.js'

// 创建axios实例
var tokens = ''
if (localStorage.getItem('tokens')) {
  tokens = 'Bearer ' + localStorage.getItem('tokens')
}
const service = axios.create({
  baseURL: env.ApiUrl,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
  }
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => {
    Toast.clear()
    return Promise.reject(error)
  }
)

// 同步执行埋点函数（核心：强制等待请求完成）
const syncTrack = (apiFunc, params) => {
  try {
    // 直接调用axios请求（绕开可能的异步封装），强制同步执行
    const token = localStorage.getItem('token') || sessionStorage.getItem('token')
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': token ? 'Bearer ' + token : ''
    }
    
    // 解析userApi/traceApi的原始请求配置（假设apiFunc是axios封装的函数）
    const requestPromise = apiFunc(params)
    // 同步等待请求完成（async/await本质是同步语法糖，不影响返回值）
    return new Promise((resolve) => {
      requestPromise
        .then(() => resolve(true))
        .catch(err => {
          console.error('埋点请求失败:', err)
          resolve(false) // 埋点失败不阻断主流程
        })
    })
  } catch (err) {
    console.error('埋点执行异常:', err)
    return Promise.resolve(false)
  }
}

// 响应拦截器
service.interceptors.response.use(
  async response => {
    var res = response.data
    console.log(response.config)

    if (res.code == 20000) {
      if (response.config.url == '/am/api/am/command/v2/prepare') {
        localStorage.setItem('qb', res.data.enableJumpBottom)
        localStorage.setItem('llg', res.data.enableJumpBottomLlg)
        localStorage.setItem('productCode', JSON.parse(response.config.data).productCode)
        localStorage.setItem('channelCode', JSON.parse(response.config.data).channelCode)

        // 同步执行埋点：等待请求完成
        await syncTrack(traceApi.event, {
          t: localStorage.getItem('traceId'),
          e: 11,
          f: res.data.reason
        })

        if (res.data.jumpBottomUrl == '0') {
          // 同步执行批量埋点
          await Promise.all([
            syncTrack(traceApi.event, {
              t: localStorage.getItem('traceId'),
              e: 110,
              f: res.data.reason
            }),
            syncTrack(userApi.statistics, {
              a: localStorage.getItem('channelCode'),
              proCode: localStorage.getItem('productCode'),
              flowType: '1',
              traceId: JSON.parse(response.config.data).traceId,
              jumpBottomUrl: res.data.jumpBottomUrl
            })
          ])
          // 正常返回res.data，和原始逻辑一致
          return res.data
        } else if (res.data.jumpBottomUrl == '3') {
          await syncTrack(traceApi.event, {
            t: localStorage.getItem('traceId'),
            e: 112,
            f: res.data.reason
          })

          if (localStorage.getItem('qb') == '1') {
            await syncTrack(userApi.statistics, {
              a: localStorage.getItem('channelCode'),
              proCode: localStorage.getItem('productCode'),
              flowType: '9',
              traceId: JSON.parse(response.config.data).traceId,
              jumpBottomUrl: res.data.jumpBottomUrl
            })

            const urlRes = await userApi.geturl({
              channelCode: localStorage.getItem('channelCode'),
              traceId: JSON.parse(response.config.data).traceId
            })
            // 同步埋点完成后再跳转
            window.location.href = urlRes.productLink
          } else {
            await syncTrack(userApi.statistics, {
              a: localStorage.getItem('channelCode'),
              proCode: localStorage.getItem('productCode'),
              flowType: '6',
              traceId: JSON.parse(response.config.data).traceId,
              jumpBottomUrl: res.data.jumpBottomUrl
            })
            store.commit('setLoading', false)
            store.commit('setLoading1', true)
          }
          const error = new Error('请求资源不存在，跳转qb兜底')
          error.code = 404
          error.data = res
          return Promise.reject(error)
        } else if (res.data.jumpBottomUrl == '2' || res.data.jumpBottomUrl == '5') {
          await syncTrack(traceApi.event, {
            t: localStorage.getItem('traceId'),
            e: 112,
            f: res.data.reason
          })

          if (localStorage.getItem('llg') == '1') {
            await syncTrack(userApi.statistics, {
              a: localStorage.getItem('channelCode'),
              proCode: localStorage.getItem('productCode'),
              flowType: '8',
              traceId: JSON.parse(response.config.data).traceId,
              jumpBottomUrl: res.data.jumpBottomUrl
            })

            var codex = res.data.jumpBottomUrl == '2' ? 'xxl' : 'defaultUrl'
            const resx = await userApi.queryByCode({ code: codex })
            window.location.href = resx.value + '&mobile=' + localStorage.getItem('mobile')
          } else {
            await syncTrack(userApi.statistics, {
              a: localStorage.getItem('channelCode'),
              proCode: localStorage.getItem('productCode'),
              flowType: '6',
              traceId: JSON.parse(response.config.data).traceId,
              jumpBottomUrl: res.data.jumpBottomUrl
            })
            store.commit('setLoading', false)
            store.commit('setLoading1', true)
          }
          const error = new Error('请求资源不存在，跳转llg兜底')
          error.code = 404
          error.data = res
          return Promise.reject(error)
        } else if (res.data.jumpBottomUrl == '4') {
          await syncTrack(traceApi.event, {
            t: localStorage.getItem('traceId'),
            e: 113,
            f: res.data.reason
          })

          await syncTrack(userApi.statistics, {
            a: localStorage.getItem('channelCode'),
            proCode: localStorage.getItem('productCode'),
            flowType: '2',
            traceId: JSON.parse(response.config.data).traceId,
            jumpBottomUrl: res.data.jumpBottomUrl
          })

          const auditRes = await userApi.getAuditLink({
            productCode: localStorage.getItem('productCode')
          })
          window.location.href = auditRes.productLink
          const error = new Error('请求资源不存在，跳转审核链接')
          error.code = 404
          error.data = res
          return Promise.reject(error)
        } else {
          await Promise.all([
            syncTrack(userApi.statistics, {
              a: localStorage.getItem('channelCode'),
              proCode: localStorage.getItem('productCode'),
              flowType: '3',
              traceId: JSON.parse(response.config.data).traceId,
              jumpBottomUrl: res.data.jumpBottomUrl
            }),
            syncTrack(traceApi.event, {
              t: localStorage.getItem('traceId'),
              e: 111,
              f: res.data.reason
            })
          ])

          store.commit('setLoading', false)
          router.replace({ path: '/404' }).catch(err => {
            console.error('路由跳转404失败：', err)
          })
          const error = new Error('请求资源不存在，跳转404页面')
          error.code = 404
          error.data = res
          return Promise.reject(error)
        }
      } else if (response.config.url == '/am/api/am/command/v2/generateToken') {
        await syncTrack(traceApi.event, {
          t: localStorage.getItem('traceId'),
          e: 10,
          f: res.data.reason
        })

        if (res.data.jumpBottomUrl == '0') {
          await Promise.all([
            syncTrack(traceApi.event, {
              t: localStorage.getItem('traceId'),
              e: 100,
              f: res.data.reason
            }),
            syncTrack(userApi.statistics, {
              a: localStorage.getItem('channelCode'),
              proCode: localStorage.getItem('productCode'),
              flowType: '14',
              traceId: JSON.parse(response.config.data).traceId,
              jumpBottomUrl: res.data.jumpBottomUrl
            })
          ])
          // 正常返回res.data
          return res.data
        } else if (res.data.jumpBottomUrl == '4') {
          await Promise.all([
            syncTrack(traceApi.event, {
              t: localStorage.getItem('traceId'),
              e: 103,
              f: res.data.reason
            }),
            syncTrack(userApi.statistics, {
              a: localStorage.getItem('channelCode'),
              proCode: localStorage.getItem('productCode'),
              flowType: '5',
              traceId: JSON.parse(response.config.data).traceId,
              jumpBottomUrl: res.data.jumpBottomUrl
            })
          ])

          const auditRes = await userApi.getAuditLink({
            productCode: localStorage.getItem('productCode')
          })
          window.location.href = auditRes.productLink
          const error = new Error('请求资源不存在，跳转审核链接')
          error.code = 404
          error.data = res
          return Promise.reject(error)
        } else if (res.data.jumpBottomUrl == '3') {
          await syncTrack(traceApi.event, {
            t: localStorage.getItem('traceId'),
            e: 102,
            f: res.data.reason
          })

          if (localStorage.getItem('qb') == '1') {
            await syncTrack(userApi.statistics, {
              a: localStorage.getItem('channelCode'),
              proCode: localStorage.getItem('productCode'),
              flowType: '13',
              traceId: JSON.parse(response.config.data).traceId,
              jumpBottomUrl: res.data.jumpBottomUrl
            })

            const urlRes = await userApi.geturl({
              channelCode: localStorage.getItem('channelCode'),
              traceId: JSON.parse(response.config.data).traceId
            })
            window.location.href = urlRes.productLink+'&mobile=' + localStorage.getItem('mobile')
          } else {
            await syncTrack(userApi.statistics, {
              a: localStorage.getItem('channelCode'),
              proCode: localStorage.getItem('productCode'),
              flowType: '6',
              traceId: JSON.parse(response.config.data).traceId,
              jumpBottomUrl: res.data.jumpBottomUrl
            })
            store.commit('setLoading', false)
            store.commit('setLoading1', true)
          }
          const error = new Error('请求资源不存在，跳转qb兜底')
          error.code = 404
          error.data = res
          return Promise.reject(error)
        } else if (res.data.jumpBottomUrl == '2') {
          await syncTrack(traceApi.event, {
            t: localStorage.getItem('traceId'),
            e: 102,
            f: res.data.reason
          })

          if (localStorage.getItem('llg') == '1') {
            await syncTrack(userApi.statistics, {
              a: localStorage.getItem('channelCode'),
              proCode: localStorage.getItem('productCode'),
              flowType: '12',
              traceId: JSON.parse(response.config.data).traceId,
              jumpBottomUrl: res.data.jumpBottomUrl
            })

            const resx = await userApi.queryByCode({ code: 'xxl' })
            window.location.href = resx.value + '&mobile=' + localStorage.getItem('mobile')
          } else {
            await syncTrack(userApi.statistics, {
              a: localStorage.getItem('channelCode'),
              proCode: localStorage.getItem('productCode'),
              flowType: '6',
              traceId: JSON.parse(response.config.data).traceId,
              jumpBottomUrl: res.data.jumpBottomUrl
            })
            store.commit('setLoading', false)
            store.commit('setLoading1', true)
          }
          const error = new Error('请求资源不存在，跳转llg链接')
          error.code = 404
          error.data = res
          return Promise.reject(error)
        } else {
          await Promise.all([
            syncTrack(traceApi.event, {
              t: localStorage.getItem('traceId'),
              e: 101,
              f: res.data.reason
            }),
            syncTrack(userApi.statistics, {
              a: localStorage.getItem('channelCode'),
              proCode: localStorage.getItem('productCode'),
              flowType: '15',
              traceId: JSON.parse(response.config.data).traceId,
              jumpBottomUrl: res.data.jumpBottomUrl
            })
          ])

          store.commit('setLoading', false)
          router.replace({ path: '/404' }).catch(err => {
            console.error('路由跳转404失败：', err)
          })
          const error = new Error('请求资源不存在，跳转404页面')
          error.code = 404
          error.data = res
          return Promise.reject(error)
        }
      } else if (response.config.url == '/am/api/am/command/encrypt/v2/signOrder') {
        // ========== 下单接口核心修复 ==========
        // 1. 同步执行埋点（等待请求完成）
        await syncTrack(traceApi.event, {
          t: localStorage.getItem('traceId'),
          e: 24,
          f: res.data.reason
        })

        if (res.data.jumpBottomUrl == '0') {
          // 2. 同步执行批量埋点
          await Promise.all([
            syncTrack(traceApi.event, {
              t: localStorage.getItem('traceId'),
              e: 240,
              f: res.data.reason
            }),
            syncTrack(userApi.statistics, {
              a: localStorage.getItem('channelCode'),
              proCode: localStorage.getItem('productCode'),
              flowType: '4',
              traceId: JSON.parse(response.config.data).traceId,
              jumpBottomUrl: res.data.jumpBottomUrl
            })
          ])
          // 3. 正常返回res.data，和原始逻辑完全一致
          return res.data
        } else if (res.data.jumpBottomUrl == '2') {
          await Promise.all([
            syncTrack(traceApi.event, {
              t: localStorage.getItem('traceId'),
              e: 242,
              f: res.data.reason
            }),
            syncTrack(userApi.statistics, {
              a: localStorage.getItem('channelCode'),
              proCode: localStorage.getItem('productCode'),
              flowType: '10',
              traceId: JSON.parse(response.config.data).traceId,
              jumpBottomUrl: res.data.jumpBottomUrl
            })
          ])

          if (localStorage.getItem('llg') == '1') {
            const resx = await userApi.queryByCode({ code: 'xxl' })
            window.location.href = resx.value + '&mobile=' + localStorage.getItem('mobile')
          } else {
            await syncTrack(userApi.statistics, {
              a: localStorage.getItem('channelCode'),
              proCode: localStorage.getItem('productCode'),
              flowType: '6',
              traceId: JSON.parse(response.config.data).traceId,
              jumpBottomUrl: res.data.jumpBottomUrl
            })
            store.commit('setLoading', false)
            store.commit('setLoading1', true)
          }
          const error = new Error('请求资源不存在，跳转llg链接')
          error.code = 404
          error.data = res
          return Promise.reject(error)
        } else if (res.data.jumpBottomUrl == '3') {
          await Promise.all([
            syncTrack(traceApi.event, {
              t: localStorage.getItem('traceId'),
              e: 242,
              f: res.data.reason
            }),
            syncTrack(userApi.statistics, {
              a: localStorage.getItem('channelCode'),
              proCode: localStorage.getItem('productCode'),
              flowType: '11',
              traceId: JSON.parse(response.config.data).traceId,
              jumpBottomUrl: res.data.jumpBottomUrl
            })
          ])

          if (localStorage.getItem('qb') == '1') {
            const urlRes = await userApi.geturl({
              channelCode: localStorage.getItem('channelCode'),
              traceId: JSON.parse(response.config.data).traceId
            })
         
            window.location.href = urlRes.productLink+'&mobile='+localStorage.getItem('mobile')
          } else {
            await syncTrack(userApi.statistics, {
              a: localStorage.getItem('channelCode'),
              proCode: localStorage.getItem('productCode'),
              flowType: '6',
              traceId: JSON.parse(response.config.data).traceId,
              jumpBottomUrl: res.data.jumpBottomUrl
            })
            store.commit('setLoading', false)
            store.commit('setLoading1', true)
          }
          const error = new Error('请求资源不存在，跳转qb链接')
          error.code = 404
          error.data = res
          return Promise.reject(error)
        } else {
          await Promise.all([
            syncTrack(traceApi.event, {
              t: localStorage.getItem('traceId'),
              e: 241,
              f: res.data.reason
            }),
            syncTrack(userApi.statistics, {
              a: localStorage.getItem('channelCode'),
              proCode: localStorage.getItem('productCode'),
              flowType: '7',
              traceId: JSON.parse(response.config.data).traceId,
              jumpBottomUrl: res.data.jumpBottomUrl
            })
          ])

          store.commit('setLoading', false)
          router.replace({ path: '/404' }).catch(err => {
            console.error('路由跳转404失败：', err)
          })
          const error = new Error('请求资源不存在，跳转404页面')
          error.code = 404
          error.data = res
          return Promise.reject(error)
        }
      } else {
        // 其他接口正常返回res.data
        return res.data
      }
    } else {
      Toast.fail(res.message)
      store.commit('setLoading', false)
      return Promise.reject(res)
    }
  },
  error => {
    Toast.clear()
    if (error.response) {
      const { data, status } = error.response
      if (status === 401) {
        localStorage.removeItem('token')
        localStorage.removeItem('tokens')
        sessionStorage.removeItem('token')
        Toast.fail(data?.message || '登录已过期，请重新登录')
      } else {
        Toast.fail(data?.message || '请求失败')
      }
    } else {
      Toast.fail(error.message || '网络请求失败')
    }
    return Promise.reject(error)
  }
)

export default service